import type { UseCaseBrief } from '../../entities/useCaseChat/UseCaseBrief';


export type DecisionBucket =
  | 'not_recommended'
  | 'significant_mitigation'
  | 'staged_deployment'
  | 'conditional_signoff'
  | 'ready'
  | 'in_progress';

export type RegisterDummyMeta = {
  decisionBucket: DecisionBucket;
  critical: number;
  major: number;
  moderate?: number;
  minor?: number;
  negligible?: number;
  tags: string[];
  impactRef: string;
  lastUpdated: string;
};

export function getImpactPlusUseCaseTitleForSidebar(
  useCaseId: string | null,
  briefsFromApi: UseCaseBrief[],
): string | null {
  if (!useCaseId) return null;
  const fromApi = briefsFromApi.find((b) => b.useCaseChatId === useCaseId);
  const apiTitle = String(fromApi?.useCaseTitle ?? '').trim();
  if (apiTitle) return apiTitle;
  return null;
}
